import { render, staticRenderFns } from "./NavbarPos.vue?vue&type=template&id=15d92b02"
import script from "./NavbarPos.vue?vue&type=script&lang=js"
export * from "./NavbarPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports